import { BlogFilterViewModel } from './BlogFilterViewModel';
import { BlogSearchViewModel } from './BlogSearchViewModel';
import { BlogPostingModel } from './BlogPostingModel';

export class BlogSearch {

    public blogSearchModel = {
        pageNumber: 1,
        pageSize: 12,
        categoryId: 0,
        categoryName: '',
        authorId: 0,
        filterValue: '',
        orderId: 1,
        direction: 'Descending'
    } as BlogFilterViewModel;

    public infiniteScrollActive = false;
    public infiniteScrollEof = false;

    constructor() {
    }

    public run(): void {
        console.log(`BlogSearchComponent run`);
        this.executePageLoadSearch();
    }

    updatePagination = (page) => {
        // Update the page number
        this.blogSearchModel.pageNumber = page;

        // Run the search automatically
        this.getBlogSearch(this.displayBlogSearch);
    }

    executePageLoadSearch = () => {
        // Check for category
        let catid = $('#hdnBlogCategory').val();
        this.blogSearchModel.categoryName = catid.toString().trim();
        this.blogSearchModel.pageNumber = 1;
        this.resetInfiniteScroll();

        // Run the search automatically
        this.getBlogSearch(this.displayBlogSearch);
    }

    executeAdvancedSearch = () => {
        // Recreate model values
        // Set model basic fields
        this.blogSearchModel.pageNumber = 1;
        this.blogSearchModel.categoryName = "";
        this.blogSearchModel.categoryId = 0; // parseInt($('#category-select').val().toString());
        this.blogSearchModel.authorId = 0;
        this.blogSearchModel.filterValue = $('#blog-search-keywords').val().toString().trim();
        this.resetInfiniteScroll();

        // Run the search automatically
        this.getBlogSearch(this.displayBlogSearch);
    }

    getBlogSearch = (callback) => {
        let bmApiUrl = '/';

        // Perform the API call
        $.ajax({
            url: `${bmApiUrl}Umbraco/Api/Blog/BlogSearch/`,
            type: "POST",
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            data: JSON.stringify(this.blogSearchModel),
            cache: false,
            crossDomain: true,
            xhrFields: {
                withCredentials: true
            },
            success: function (r) {
                console.log(`getBlogSearch success`);
                callback(r);
            },
            error: function (e) {
                console.log(e);
                callback(e);
            }
        });
    };

    displayBlogSearch = (data: BlogSearchViewModel) => {
        console.log(`displayBlogSearch start`);
 
        // Featured item
        if (data.featuredItem != null) {
            let featuredHtml = "";

            featuredHtml += "<a href=\"" + data.featuredItem.url + "\" class=\"article-link\">";
            featuredHtml += "   <div class=\"article featured\"> ";
            featuredHtml += "     <div class=\"row\">";
            featuredHtml += "        <div class=\"col col-xs-12 col-lg-6\">";
            featuredHtml += "            <div class=\"image-left\">";

            if (data.featuredItem.thumbnailUrl != null && data.featuredItem.thumbnailUrl != undefined) {
                featuredHtml += "           <div class=\"background\" style=\"background-image: url('" + data.featuredItem.thumbnailUrl + "')\"></div>";
            }

            featuredHtml += "            </div>";
            featuredHtml += "        </div>";
            featuredHtml += "        <div class=\"col col-xs-12 col-lg-6\">";
            featuredHtml += "            <div class=\"info-right\">";
            featuredHtml += "                <p class=\"sector-date\">" + data.featuredItem.postingDateString + "</p>";
            featuredHtml += "                <h3>" + data.featuredItem.title + "</h3>";
            featuredHtml += "                <p>" + data.featuredItem.summary + "</p>";
            featuredHtml += "                <div class=\"tag-wrapper\">";

            for (let cat of data.featuredItem.categories) {
                featuredHtml += "               <a href=\"/why-bricks-mortar/blog/category/" + cat.name.replace(' ', '-') +"\" class=\"tag\">" + cat.name + "</a>";
            }

            featuredHtml += "               </div>";
            featuredHtml += "            </div>";
            featuredHtml += "        </div>";
            featuredHtml += "     </div>";
            featuredHtml += "   </div>";
            featuredHtml += "</a>";

            $('.blog-featured-item').html(featuredHtml);
        }

        let baseUrl = window.location.protocol + "//" + window.location.host;

        // Listing items
        if (data.resultItems != null) {
            if (data.resultItems.length > 0) {
                $('.result-count').text(`Displaying 1-${data.recordsUpper} of ${data.totalRecords} articles`);
                for (let post of data.resultItems) {
                    let blogPost = this.writeBlogItem(post);
                    $(blogPost).appendTo('.blog-listing-items');
                }
            } else {
                this.infiniteScrollEof = true;
                $('#dyn-scroll-to-load-more').fadeOut(100);
                $('.result-count').text(`No matching articles found, please search again`);
            }
        } else {
            this.infiniteScrollEof = true;
            $('#dyn-scroll-to-load-more').fadeOut(100);
            $('.result-count').text(`No matching articles found, please search again`);
        }

        // Reset heights
        this.setupContentResize();

        // Remove loading
        $("#loading-wrapper").remove();
        $('body').removeClass('loading-active');
    }

    getBlogSearchFromInfiniteScroll = (callback) => {
        let bmApiUrl = '/';

        // Perform the API call
        $.ajax({
            url: `${bmApiUrl}Umbraco/Api/Blog/BlogSearch/`,
            type: "POST",
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            data: JSON.stringify(this.blogSearchModel),
            cache: false,
            crossDomain: true,
            xhrFields: {
                withCredentials: true
            },
            success: function (r) {
                console.log(`getBlogSearchFromInfiniteScroll success`);
                callback(r);
            },
            error: function (e) {
                console.log(e);
                callback(e);
            }
        });
    }

    displayBlogSearchFromInfiniteScroll = (data: BlogSearchViewModel) => {
        console.log(`displayBlogSearchFromInfiniteScroll start`);

        let baseUrl = window.location.protocol + "//" + window.location.host;

        // Listing items
        if (data.resultItems != null) {
            if (data.resultItems.length > 0) {
                $('.result-count').text(`Displaying 1-${data.recordsUpper} of ${data.totalRecords} articles`);
                for (let post of data.resultItems) {
                    let blogPost = this.writeBlogItem(post);
                    $(blogPost).appendTo('.blog-listing-items');
                }
            } else {
                this.infiniteScrollEof = true;
                $('#dyn-scroll-to-load-more').fadeOut(100);
            }
        } else {
            this.infiniteScrollEof = true;
            $('#dyn-scroll-to-load-more').fadeOut(100);
        }

        // Reset heights
        this.setupContentResize();

        // Remove loading
        $("#loading-wrapper").remove();
        $('body').removeClass('loading-active');

        this.infiniteScrollActive = false;
    }

    setupContentResize() {
        $('.blog-posting-content').css('height', 'auto');
        if ($(window).width() > 767) {
            var maxOuterHeight = 0;
            $('.blog-posting-content').each(function () {
                if ($(this).outerHeight() > maxOuterHeight) { 
                    maxOuterHeight = $(this).outerHeight(); 
                }
            });
            $('.blog-posting-content').outerHeight(maxOuterHeight);          
        }        
    }

    writeBlogItem(post: BlogPostingModel) {
        let blogPost = "";
        let baseUrl = window.location.protocol + "//" + window.location.host;

        blogPost += "<div itemscope itemtype=\"https://schema.org/BlogPosting\" class=\"col-xs-12 col-sm-12 col-lg-3 blog-posting\">";
        blogPost += " <div class=\"news-item\">";
        blogPost += "    <div class=\"row news-image-wrap\">";
        blogPost += "    <meta itemprop=\"author\" content=\"Bricks & Mortar\">";
        blogPost += "    <meta itemprop=\"datePublished\" content=\""+ post.postingDate +"\">";
        blogPost += "    <meta itemprop=\"dateModified\" content=\""+ post.postingDate +"\">";
        blogPost += "    <span itemprop=\"publisher\" itemscope itemtype=\"https://schema.org/Organization\">";
        blogPost += "        <meta itemprop=\"name\" content=\"Bricks & Mortar\">";
        blogPost += "        <span itemprop=\"logo\" itemscope itemtype=\"https://schema.org/ImageObject\">";
        blogPost += "            <meta itemprop=\"url\" content=\""+ baseUrl +"/dist/images/logo.png\">";
        blogPost += "        </span>";
        blogPost += "    </span>";

        if (post.thumbnailUrl != null && post.thumbnailUrl != undefined) {
            blogPost += "   <a href=\""+ post.url +"\">";
            blogPost += "       <span itemprop=\"image\" itemscope itemtype=\"http://schema.org/ImageObject\">";
            blogPost += "           <meta itemprop=\"url\" content=\""+ baseUrl + post.thumbnailUrl +"\">";
            blogPost += "           <img itemprop=\"image\" itemscope itemtype=\"https://schema.org/ImageObject\" src=\""+ baseUrl + post.thumbnailUrl +"\" alt=\"\" border=\"0\" class=\"thumbnail-image\" />";
            blogPost += "       </span>";
            blogPost += "   </a>";
        }

        blogPost += "   </div>";

        blogPost += "   <div class=\"row\">";
        blogPost += "       <div class=\"blog-posting-content\">";
        blogPost += "           <h4 itemprop=\"headline\">" + post.title + "</h4><p itemprop=\"description\">"+ post.summary +"</p>";
        blogPost += "       </div>";
        blogPost += "       <a itemprop=\"mainEntityOfPage url\" href=\""+ baseUrl + post.url +"\" class=\"more-link\">More information <i class=\"fas fa-angle-right\"></i></a>";
        blogPost += "   </div>";

        blogPost += " </div>";
        blogPost += "</div>";

        return blogPost;
    }

    infiniteScroll = (cancel: boolean) => {
        if (!this.infiniteScrollActive && !this.infiniteScrollEof){
            this.infiniteScrollActive = true;

            if (this.blogSearchModel.pageNumber == null || this.blogSearchModel.pageNumber == undefined || this.blogSearchModel.pageNumber === 0) { this.blogSearchModel.pageNumber = 1; }
            let currentPageNo = this.blogSearchModel.pageNumber;
            this.blogSearchModel.pageNumber = currentPageNo + 1;
            console.log("infiniteScroll " + currentPageNo + "_" + this.blogSearchModel.pageNumber);

            // Run the search automatically
            this.getBlogSearchFromInfiniteScroll(this.displayBlogSearchFromInfiniteScroll);
        }
    }
    
    resetInfiniteScroll = () => {
        this.infiniteScrollActive = false;
        this.infiniteScrollEof = false;
        $('#dyn-scroll-to-load-more').fadeIn(100);
    }
}

$(document).ready(function () {

    var blogSearch = new BlogSearch();
    blogSearch.run();

    var addLoading = function () {
        var loading = document.createElement('div');
        loading.id = "loading-wrapper";
        //var loader = document.createElement('div');
        //loader.className = "loading-icon";
        //loading.appendChild(loader);
        $('body').append(loading.outerHTML);
        $('body').addClass('loading-active');
        $('#main-navigation').scrollTop(300);
        $("html, body").animate({ scrollTop: $("#category-filter").offset().top - 100 }, 1000);
    }

    $('.blog-search-update, .blog-search-update-category').on('click', function (e) {
        e.preventDefault();

        $('.blog-listing-items').html('');
        $('.pagination').html('');
        addLoading();

        blogSearch.executeAdvancedSearch();
    });

    $(document).on('click', '.pagination-action', function (e) {
        e.preventDefault();

        var pageNo = $(this).attr("data-pageno");
        $('.blog-listing-items').html('');
        $('.pagination').html('');
        addLoading();

        blogSearch.updatePagination(pageNo);
    });

    $(window).scroll(function () {
        var scrollHintToTop = $("#dyn-scroll-to-load-more").position().top;
        var currentScroll = $(this).scrollTop();
        if (currentScroll > (scrollHintToTop - 1000)) {
            blogSearch.infiniteScroll(false);
        }
    });

});


// WEBPACK FOOTER //
// ./App/BlogSearch.ts